import { BASE } from '../../utils/service-providers';

export const INVESTMENT_ENDPOINT = (investment_id?: string) =>
  `${BASE}/investments/${investment_id ? investment_id : ''}`;
export const MANAGER_ASSOCIATION_META_ENDPOINT = (investment_id?: string) =>
  `${INVESTMENT_ENDPOINT(investment_id)}/manager-association-meta`;
export const SUBMISSION_ENDPOINT = (submission_id?: string) =>
  `${BASE}/submissions/${submission_id ? submission_id : ''}`;
export const SUBMISSION_REQUEST_ENDPOINT = (subReqId?: string) =>
  `${BASE}/submission-requests${subReqId ? '/' + subReqId : ''}`;
export const SUBMISSION_ERRORS_ENDPOINT = (submission_id: string) =>
  `${SUBMISSION_ENDPOINT(submission_id)}/errors`;
export const ERROR_REPORT_DOWNLOAD_ENDPOINT = (submission_id: string) =>
  `${SUBMISSION_ENDPOINT(submission_id)}/error-report`;
export const SUBMISSION_BYPASSABLE_ERRORS_ENDPOINT = (submission_id: string) =>
  `${SUBMISSION_ENDPOINT(submission_id)}/bypassable-errors`;
export const SUBMISSION_REQUEST_REOPEN_ENDPOINT = (subReqId?: string) =>
  `${SUBMISSION_REQUEST_ENDPOINT(subReqId)}/reopen`;
export const FETCH_SUBMISSION_FOR_BATCH = (batch_id?: string) =>
  `${BASE}/submissions/batch/${batch_id ? batch_id : ''}`;
export const DOWNLOAD_ERROR_REPORTS_FOR_BATCH = (batch_id?: string) =>
  `${BASE}/submissions/${batch_id ? batch_id : ''}/error-reports`;
export const FETCH_ERROR_REPORTS_URL_FOR_BATCH = (job_id?: string) =>
  `${BASE}/submissions/${job_id ? job_id : ''}/error-reports/download`;
